/*
 * @Author: your name
 * @Date: 2021-12-15 16:41:56
 * @LastEditTime: 2021-12-21 15:28:58
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \gw-react\src\pages\App.js
 */
import React from "react";

import { Route, Routes } from "react-router-dom";
import Home from "./home/index";
import Product from "./product";
import ProjectMap from "./projectMap";
import Unit from "./unit";
import LinkMap from "./linkMap";
import Port from "./port618";
import Header from "../components/header";
import Buttom from "../components/buttom";

import { connect } from "react-redux";
import { requestAction } from "../store/actionCreators";
class App extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.requestUsersInfo();
  }
  render() {
    let { earList } = this.props;

    return (
      <div>
        <Header></Header>
        <Routes>
          {/* <Route path="/login" component={Login}/> */}
          <Route path="/home" element={<Home />} />
          <Route path="/product" element={<Product />} />
          <Route path="/projectMap" element={<ProjectMap />} />
          <Route path="/unit" element={<Unit />} />
          <Route path="/port" element={<Port />} />
          <Route path="/linkMap" element={<LinkMap earList={earList} />}>
            {/* <Route path="/linkMap" element={<LinkMap />}></Route> */}
          </Route>
          <Route path="*" element={<Home />} />
        </Routes>
        <Buttom></Buttom>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  console.log("state", state);
  return {
    earList: state || [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    requestUsersInfo() {
      dispatch(requestAction);
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
